// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__74kss","errors":"Errors_errors__3maiU"};